import styled from 'styled-components'
import CardIcons from '../CardIcons/CardIcons'

export const CardIcon = styled(CardIcons)`
  width: auto;
  height: 1.5rem;
  margin-inline-end: 0.5rem;
  margin-top: 1rem;
`
